module.exports = __webpack_public_path__ + "static/media/patient-engagement@2x.b67ce3b7.png";